import CardHistoryTrans from '@/entities/profile-page/historyTransactions/CardHistoryTrans'
import { useInView } from 'react-intersection-observer'

export const HistoryTransactions = () => {
    const { ref, inView } = useInView({
        threshold: 0,
        triggerOnce: true,
    })
    return (
        <div
            ref={ref}
            className={`HistoryTransactions ${
                inView && 'animate__animated animate__zoomInRight'
            }`}
        >
            <h2>История транзакций</h2>
            <div className={'history-content'}>
                <CardHistoryTrans
                    dataHistory={{
                        transaction: 10089,
                        status: 'Оформлен возврат',
                    }}
                />
            </div>
        </div>
    )
}
